import { defineStyleConfig } from '@chakra-ui/react'

export const Skeleton = defineStyleConfig({
    baseStyle: {
        rounded: 'lg',
    },
})
